import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { useTheme } from "../../context/ThemeContext";
import { getAppTheme } from "../../config/resolve-app-brand";
import { default_headers } from "../../utils/api";
import envConfig from "../../config";
import { checkAndUpdateApiKeyExpiration } from "../Dashboard/Dashboard";

const transformString = (inputString) => {
  const words = inputString.split(/\s+/);

  const transformedWords = words.map((word) => {
    const lowercasedWord = word.toLowerCase();
    return lowercasedWord.charAt(0).toUpperCase() + lowercasedWord.slice(1);
  });
  return transformedWords.join(" ");
};

const LookupAbn = ({
  businessName,
  abn,
  abnApiResult,
  setAbnApiResult,
  setIsAbnOpen,
  setAbnResultsAccepted,
}) => {
  const { isDarkMode } = useTheme();
  const theme = getAppTheme(isDarkMode);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://${envConfig.apiDev1}/api/v3/en-au/contacts/abn-lookup?taxCode=${abn}&BaseHostURL=${envConfig.loginUrl}`,
          {
            method: "POST",
            headers: {
              ...default_headers,
              Accept: "application/json",
              "olivs-api-real-ip": "31.42.0.186",
              "olivs-api-computer-name": "EC2AMAZ-QF1CQAD",
              "browser-agent": window.navigator.userAgent,
              "api-key": "OlivsAuth",
            },
          }
        );
        const data = await response.json();
        checkAndUpdateApiKeyExpiration();
        setAbnApiResult(data);
        setIsLoading(false);
      } catch (error) {
        setIsAbnOpen(false);
        // Error handled by interceptor
      }
    };
    fetchData();
  }, []);

  if (abnApiResult?.ErrorMessage || abnApiResult?.ErrorMessage !== "") return;
  if (isLoading) return;
  const displayName = abnApiResult.LastName
    ? abnApiResult.OtherName
      ? `${abnApiResult.FirstName} ${abnApiResult.OtherName} ${abnApiResult.LastName}`
      : `${abnApiResult.FirstName} ${abnApiResult.LastName}`
    : abnApiResult.EntityName;
  return (
    <div>
      <DialogContent data-testid="lookup-abn--DialogContent-0">
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            mb: 1,
          }}
        >
          <Typography sx={{ width: "210px" }}>Business Name:</Typography>
          <Typography>{displayName}</Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",

            mb: 1,
          }}
        >
          <Typography sx={{ width: "210px" }}>Business Type:</Typography>
          <Typography>{abnApiResult.EntityDescription}</Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            mb: 1,
          }}
        >
          <Typography sx={{ width: "210px" }}>Is GST Registered:</Typography>
          <Typography>{abnApiResult.GSTRegistered}</Typography>
        </Box>
        {abn && (
          <p>
            {`Check the record on `}
            <a
              style={{
                marginTop: "30px",
                color: theme.palette.primary.main,
                textDecoration: "none",
              }}
              href={`https://abn.business.gov.au/ABN/View?abn=${abn}`}
              target="_blank"
              data-testid="lookup-abn--a-0">
              ABN Lookup
            </a>
          </p>
        )}
      </DialogContent>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          justifyContent: "flex-end",
          textAlign: "right",
          mb: 2,
        }}
      >
        <Button
          variant="contained"
          color="primary"
          sx={{ mb: 1, ml: 2, mr: 2 }}
          onClick={() => {
            console.log("abnApiResult", abnApiResult);
            setAbnResultsAccepted({ ...abnApiResult, EntityName: displayName });
            setIsAbnOpen(false);
          }}
          data-testid="lookup-abn--Button-0">
          Insert with upper case
        </Button>
        <Button
          variant="contained"
          color="primary"
          sx={{ ml: 2, mr: 2 }}
          onClick={() => {
            console.log("abnApiResult", abnApiResult);
            setAbnResultsAccepted({
              ...abnApiResult,
              EntityName: transformString(displayName),
            });
            setIsAbnOpen(false);
          }}
          data-testid="lookup-abn--Button-1">
          Insert with lower case
        </Button>
        <Button
          sx={{
            background: "transparent",
            mr: 2,
            ml: 2,
            bt: 1,
            mb: 1,
            "&:hover": {
              background: "transparent",
            },
          }}
          disableRipple
          variant="outlined"
          onClick={() => setIsAbnOpen(false)}
          data-testid="lookup-abn--Button-2">
          Cancel
        </Button>
      </Box>
    </div>
  );
};

export default LookupAbn;
